import styled            from 'styled-components';

import { cssFlexColumn } from 'src/providers/theme/shared';



type ProductDialogLookAndFeel = {
  padding: number[]; 
  gap: number;
}

const product_dialog_main: ProductDialogLookAndFeel = {
  padding: [24, 26],
  gap: 16,
}

export type ProductDialogVariants = 'product_dialog_main'

export const product_dialog_variants: Map<ProductDialogVariants, ProductDialogLookAndFeel> = new Map<ProductDialogVariants, ProductDialogLookAndFeel>([
  ['product_dialog_main', product_dialog_main],
]);

export const Container = styled.div<{
  lookAndFeel: ProductDialogLookAndFeel
}>`
  ${cssFlexColumn};
  padding: ${(args) => args.lookAndFeel.padding[0]}px ${(args) => args.lookAndFeel.padding[1]}px;
  gap: ${(args) => args.lookAndFeel.gap}px;
`

export const ProductList = styled.div<{
  lookAndFeel: ProductDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;
`
